/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentDataViewModel } from "../types/PersonDocumentDataViewModel.ts";
import { eForeignDocumentSchema } from "./eForeignDocumentSchema.ts";

export const personDocumentDataViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("Identificador único da pessoa.")),
  cpf: z.string().describe("CPF da pessoa. Opcional.").nullish(),
  rg: z.string().describe("RG da pessoa. Opcional.").nullish(),
  dispatcherOrgan: z
    .string()
    .describe("Órgão emissor do RG. Opcional.")
    .nullish(),
  dispatcherOrganState: z
    .string()
    .describe("Estado do órgão emissor do RG. Opcional.")
    .nullish(),
  dateDispatch: z
    .string()
    .datetime()
    .describe("Data de emissão do RG. Opcional.")
    .nullish(),
  passportNumber: z
    .string()
    .describe("Número do passaporte da pessoa. Opcional.")
    .nullish(),
  idCountryNumber: z
    .string()
    .describe(
      "Número do documento de identidade estrangeiro da pessoa. Opcional.",
    )
    .nullish(),
  idForeignDocument: z.optional(
    z
      .lazy(() => eForeignDocumentSchema)
      .describe("1 = IdentificationDocument | 2 = Passport | 3 = RneRnm | "),
  ),
  crnm: z
    .string()
    .describe(
      "Número do Cadastro de Registro Nacional Migratório (CRNM) da pessoa. Opcional.",
    )
    .nullish(),
  crnmIssueDate: z
    .string()
    .datetime()
    .describe("Data de emissão do CRNM. Opcional.")
    .nullish(),
  crnmExpirationDate: z
    .string()
    .datetime()
    .describe("Data de vencimento do CRNM. Opcional.")
    .nullish(),
  cin: z
    .string()
    .describe(
      "Número da Carteira de Identidade Nacional (CIN) da pessoa. Opcional.",
    )
    .nullish(),
  idpecege: z
    .string()
    .describe("Identificador interno da pessoa no sistema Pecege. Opcional.")
    .nullish(),
  verifiedDocumentData: z.optional(
    z
      .boolean()
      .describe("Indica se os dados documentais da pessoa foram verificados."),
  ),
}) as unknown as ToZod<PersonDocumentDataViewModel>;
